import { Card, Divider, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { GeneralTable } from 'src/components/general';
import { CONTENT_SELECTION_TABLE_HEAD } from 'src/constants/tableHeads';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import useTable from 'src/hooks/useTable';
import { useFetchGamesList } from 'src/network/games';
import ContentSelectionTableRow from './ContentSelectionTableRow';
import ContentSelectionTableToolbar from './ContentSelectionTableToolbar';
import GeneralFiltersAccordionWrapper from 'src/components/general/GeneralFiltersAccordionWrapper';

// ----------------------------------------------------------------------

export default function ContentSelectionTableModal({ selectContentHandler }) {
  const useTableOptions = useTable();
  const { page, onChangePage } = useTableOptions;

  const [tableData, setTableData] = useState([]);

  const [gameListFilters] = useLocalStorage('gameListFilters');
  const [savedPage, setSavedPage] = useLocalStorage('savedPage');

  const [filterItems, setFilterItems] = useState({
    Title: gameListFilters?.Title || '',
    CategoryID: gameListFilters?.CategoryID || -1,
    GameID: gameListFilters?.GameID || 0,
    IsLunchGame: 0,
  });

  // ----------------------------------------------------------------------

  const { isLoading, data } = useFetchGamesList(filterItems, page);

  useEffect(() => {
    if (data) {
      const gamesList = data?.data?.items || [];
      setTableData([...gamesList]);
      setSavedPage({
        pageIndex: page,
        pageName: 'games-list',
      });
    }
  }, [data, page, filterItems]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ p: 2, overflow: 'visible' }}>
          <GeneralFiltersAccordionWrapper>
            <ContentSelectionTableToolbar setFilterItems={setFilterItems} onChangePage={onChangePage} />
          </GeneralFiltersAccordionWrapper>

          <Divider sx={{ my: 2 }} />

          <GeneralTable
            tableContainerSX={{ position: 'relative' }}
            rowID="GameID"
            tableData={tableData}
            headLabel={CONTENT_SELECTION_TABLE_HEAD}
            CustomTableRow={ContentSelectionTableRow}
            useTableOptions={useTableOptions}
            hasDeleteOption={false}
            selectContentHandler={selectContentHandler}
            isLoading={isLoading}
          />
        </Card>
      </Grid>
    </Grid >
  );
}
